import { render, staticRenderFns } from "./ServiceFormWrapper.vue?vue&type=template&id=0584d362"
import script from "./ServiceFormWrapper.vue?vue&type=script&lang=js"
export * from "./ServiceFormWrapper.vue?vue&type=script&lang=js"
import style0 from "./ServiceFormWrapper.vue?vue&type=style&index=0&id=0584d362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports